export default __webpack_public_path__ + "e21465e72c7a2a5ea7186961da050b01.svg";